import React, { useRef } from 'react';
import ReservationTable from 'components/management/tables/ReservationTable';
import { AdminReservationDto } from 'services/data-contracts';
import { useStoreWrapper } from 'stores/StoreHelper';
import WeeklyCalendar from 'components/WeeklyCalendar';
import ReservationDailyFilter from 'components/management/filters/ReservationDailyFilter';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';
import ReservationDetail from 'components/management/ReservationDetail';
import { ReservationDailyFilterType } from 'types/CommonTypes';
import { ApiResponse } from 'services/http-client';
import ServiceHelper from 'stores/ServiceHelper';
import moment from 'moment';
interface StatusProps {
  status: 'NEW' | 'CONFIRMED' | 'FAILED' | 'CANCELLED' | 'COMPLETED';
}

const ReservationDailyPage = observer(() => {
  const { uiStore, reservationFilterStore } = useStoreWrapper();
  const selectedDateRef = useRef<string>(moment().format('YYYY-MM-DD'));

  const onFilterChange = (filter: ReservationDailyFilterType) => {
    reservationFilterStore.setDailiyFilter(filter);
  };

  // const handleClickExcel = async () => {
  //   try {
  //     const response = (await ServiceHelper?.adminReservationService?.exportReservationsByPeriod(
  //       {
  //         fromDate: selectedDateRef.current || '',
  //         toDate: selectedDateRef.current || '',
  //         periodType: 'RESERVATION',
  //       },
  //       {
  //         format: 'blob',
  //       },
  //     )) as unknown as ApiResponse<Blob>;

  //     if (!response?.response?.data) {
  //       return;
  //     }
  //     const blob = response.response.data;
  //     const url = window.URL.createObjectURL(blob);
  //     const link = document.createElement('a');
  //     link.href = url;
  //     link.setAttribute('download', `reservations_${moment().format('YYYYMMDD')}.xlsx`);
  //     document.body.appendChild(link);
  //     link.click();
  //     link.remove();
  //     window.URL.revokeObjectURL(url);
  //   } catch (error) {
  //     console.error('Error downloading Excel file:', error);
  //   }
  // };

  const handleClickDate = (date: string) => {
    selectedDateRef.current = date;
    reservationFilterStore.getReservationByDaily({
      type: 'all',
      date: date,
    });
  };

  const getStatusText = (status: StatusProps['status']) => {
    switch (status) {
      case 'NEW':
        return '예약완료';
      case 'CONFIRMED':
        return '확정';
      case 'FAILED':
        return '실패';
      case 'CANCELLED':
        return '취소';
      case 'COMPLETED':
        return '완료';
      default:
        return '알 수 없음';
    }
  };

  const handleRowClick = (reservation: AdminReservationDto) => {
    uiStore?.modal.show({
      title: (
        <div>
          {reservation.reservationNo}{' '}
          <Status status={reservation.status as StatusProps['status']}>
            {getStatusText(reservation.status as StatusProps['status'])}
          </Status>
        </div>
      ),
      style: { maxWidth: '1200px', height: '100%', maxHeight: '80vh' },
      children: <ReservationDetail reservation={reservation} />,
    });
  };

  return (
    <div>
      <WeeklyCalendar onClickDate={handleClickDate} />
      <div style={{ padding: '0 20px', marginTop: 10 }}>
        <ReservationDailyFilter onclick={onFilterChange} />
        <div style={{ paddingBottom: 100 }}>
          <ReservationTable
            reservations={reservationFilterStore.filteredReservations}
            onRowClick={handleRowClick}
          />
          {/* <Pagination count={reservationFilterStore.paginationInfo?.totalPages ?? 0} onChange={handleChangePage} variant="outlined" shape="rounded" /> */}
        </div>
        {/* <ScrollUpButtonWrapper>
          <ArrowUpwardIcon style={{ color: 'white' }} />
        </ScrollUpButtonWrapper> */}
        {reservationFilterStore.filteredReservations.length === 0 && (
          <EmptyText>검색 결과가 없습니다.</EmptyText>
        )}
      </div>
    </div>
  );
});

const EmptyText = styled.div`
  text-align: center;
  margin-top: 20px;
`;

const Status = styled.span<StatusProps>`
  display: inline-flex;
  align-items: center;
  padding: 4px 30px;
  border-radius: 12px;
  font-size: 13px;
  justify-content: flex-start;
  font-weight: 500;
  background-color: ${(props) => {
    if (props.status === 'NEW') return '#e6f7e6';
    if (props.status === 'CONFIRMED') return 'rgb(230, 247, 255)';
    if (props.status === 'FAILED') return '#fff8e6';
    if (props.status === 'CANCELLED') return '#f5f5f5';
    if (props.status === 'COMPLETED') return '#f5f5f5';
    return '#f5f5f5';
  }};
  color: ${(props) => {
    if (props.status === 'NEW') return '#2a8d2a';
    if (props.status === 'CONFIRMED') return '#0067a7';
    if (props.status === 'FAILED') return '#c19c00';
    if (props.status === 'CANCELLED') return '#666';
    if (props.status === 'COMPLETED') return '#666';
    return '#666';
  }};
`;

// const ScrollUpButtonWrapper = styled(ScrollUpButton)`
//   width: 50px;
//   height: 50px;
//   opacity: 0.3;
//   transition: opacity 0.3s ease;

//   &:hover {
//     opacity: 1;
//   }
//   > button {
//     width: 50px !important;
//     height: 50px !important;
//     background: var(--point-color) !important;
//   }
// `;
export default ReservationDailyPage;
